// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean, nullOrUndefined, number } from "@altostra/type-validations/lib/primitives";

export const isPostFreeTrialDeveloperResult = objectOf({
  info: string,
  developer: objectOf({
    _id: string,
    email: string,
    first_name: string,
    last_name: string,
    full_name: string,
    department: string,
    image_url: string,
    two_factor_auth_enabled: boolean,
    selected_tfa_flow_type: nullOrUndefined,
    braze_support_portal_access: boolean,
    subscribed_to_report: boolean,
    confirmed: boolean,
    last_signed_in_at: number,
    sign_in_count: nullOrUndefined,
    permissions: arrayOf(
      objectOf({
        scope: number,
        scope_id: string,
        name: number,
        context: objectOf({
          company_id: string,
          app_group_id: string,
        }),
      })
    ),
    adhoc_permissions: arrayOf(nullOrUndefined),
    permission_set_assignments: arrayOf(
      objectOf({
        ag_id: string,
        agps_id: string,
      })
    ),
    custom_role_assignments: arrayOf(nullOrUndefined),
    company_id: string,
    is_suspended: boolean,
  }),
});
